import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

import {
    EdataFormatIndex,
    numbersDataFormat,
    percentDataFormat,
} from "../components/ChannelsOverviewBarChart/ChannelsOverviewBarChartContainerFormat";

import { BetaTrafficSource } from "./types/types";
const { midnight, blue, sky } = colorsPalettes;

export const MARKETING_CHANNELS_BETA_UI_PREF_KEY = "marketing_channels_beta_ui";

export const filterBetaMmxChannels = [
    "Direct",
    "Search - Organic",
    "Search - Paid",
    "Referrals",
    "Display",
    "Social - Organic",
    "Social - Paid",
    "Gen AI",
    "Email",
];

export const dataFormatToIndex = {
    [numbersDataFormat]: EdataFormatIndex.NUMBERS,
    [percentDataFormat]: EdataFormatIndex.PERCENT,
};

export const indexToDataFormat = {
    [EdataFormatIndex.NUMBERS]: numbersDataFormat,
    [EdataFormatIndex.PERCENT]: percentDataFormat,
};
export const BetaTrafficSourceDisplayMap: { [key in BetaTrafficSource]: { text: string; color: string } } = {
    [BetaTrafficSource.Direct]: {
        get text() {
            return translate("utils.direct");
        },
        color: midnight["500"],
    },
    [BetaTrafficSource.OrganicSearch]: {
        get text() {
            return translate("Search - Organic");
        },
        color: blue[600],
    },
    [BetaTrafficSource.PaidSearch]: {
        get text() {
            return translate("Search - Paid");
        },
        color: blue["500"],
    },
    [BetaTrafficSource.Referrals]: {
        get text() {
            return translate("utils.referrals");
        },
        color: blue["400"],
    },
    [BetaTrafficSource.Display]: {
        get text() {
            return translate("Display");
        },
        color: blue["350"],
    },
    [BetaTrafficSource.SocialOrganic]: {
        get text() {
            return translate("Social - Organic");
        },
        color: blue["300"],
    },
    [BetaTrafficSource.SocialPaid]: {
        get text() {
            return translate("Social - Paid");
        },
        color: sky["200"],
    },
    [BetaTrafficSource.GenAi]: {
        get text() {
            return translate("Gen AI");
        },
        color: blue["100"],
    },
    [BetaTrafficSource.Email]: {
        get text() {
            return translate("utils.email");
        },
        color: midnight["50"],
    },
};
export const DATE_FORMATTER = "YYYY-MM-DD";
export const DEFAULT_CHANNEL_TRAFFIC_SOURCE = "Direct";
